import Navbar from "@/components/feature/Navbar";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import BlogSection from "./components/BlogSection";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://acbuyspreadsheet.delivery";

export default function Home() {
  return (
    <main>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "ACBuySpreadsheet Hub",
            "url": siteUrl,
            "description":
              "The most trusted knowledge base and guide platform for acbuyspreadsheet systems, tools, and usage strategies.",
            "potentialAction": {
              "@type": "SearchAction",
              "target": `${siteUrl}/search?q={search_term_string}`,
              "query-input": "required name=search_term_string",
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "ACBuySpreadsheet Hub",
            "url": siteUrl,
            "description":
              "The most trusted knowledge base for acbuyspreadsheet systems. Discover complete guides, honest comparisons, safety breakdowns, and expert strategies for smarter spreadsheet management and workflow optimization.",
            "sameAs": ["https://kaspreadsheet.com/"],
          }),
        }}
      />
      <Navbar />
      <HeroSection />
      <CategoryGrid />
      <BlogSection />
      <CTASection />
      <Footer />
    </main>
  );
}